import { MobileStatusRemoteDto } from '../../../../../generated/signalR/mobile-status-remote-dto';

export class MobileStatusValuesUpdated {
   public static readonly type = '[MobileStatus] mobile status values updated';

   constructor(public mobileStates: MobileStatusRemoteDto[]) {}
}
